import { useState } from "react";
import { useEffect } from "react";

import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { useMediaQuery } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { useTheme } from "@mui/material/styles";

import OmniAssessmentImageListItem from "../ui/omniAssessmentImageListItem";

const QuestionSingleImageSelectDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const defaultDelay = 350;
  const theme = useTheme();

  //just manages state
  const [localAnswer, setLocalAnswer] = useState(question.answerValue ? question.answerValue : []);

  useEffect(() => {
    if (question.answerValue) {
      setLocalAnswer(question.answerValue);
    }
  }, [question, setLocalAnswer]);

  const numColumns = 4;
  const mobileColumns = 2;
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ImageList cols={mobileLayout ? mobileColumns : numColumns} sx={{ maxHeight: 500 }}>
      {question.answerOptions.map((answerOption, index) => (
        <OmniAssessmentImageListItem
          color="primary"
          size="large"
          variant={"outlined"}
          key={`answerOptionImage${index}`}
          onClick={e => {
            e.stopPropagation();
            setLocalAnswer([answerOption.value]);
            onAnswerSelected([answerOption.value]);
            startNextTimer(defaultDelay);
          }}
        >
          <img
            //below works
            srcSet={`${answerOption.subText}?fit=crop&auto=format&dpr=2 2x`}
            src={`${answerOption.subText}?fit=crop&auto=format`}
            alt={answerOption.text}
            loading="lazy"
            sx={{ maxHeight: 200 }}
          />
          <ImageListItemBar
            sx={{ maxHeight: 42, color: theme.palette.secondary.contrastText }}
            title={answerOption.text}
            subtitle={
              answerOption.helpText ? <span>by: {answerOption.helpText}</span> : "Click to Select"
            }
            position="below"
            actionIcon={
              (localAnswer && localAnswer.includes(answerOption.value)) ||
              (!localAnswer &&
                question.answerValue &&
                question.answerValue.includes(answerOption.value)) ? (
                <RadioButtonChecked
                  sx={{
                    marginTop: theme.spacing(1.5),
                    color: theme.palette.secondary.contrastText,
                  }}
                />
              ) : (
                <RadioButtonUnchecked
                  sx={{
                    marginTop: theme.spacing(1.5),
                    color: theme.palette.secondary.contrastText,
                  }}
                />
              )
            }
          />
        </OmniAssessmentImageListItem>
      ))}
    </ImageList>
  );
};

export default QuestionSingleImageSelectDisplay;
